import PropTypes from 'prop-types';

import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

const TimeRangeRadios = ({ radio: { name, value, onChange, disabled } }) => (
  <RadioGroup name={name} value={value} onChange={onChange}>
    <Box display="flex" alignItems="center">
      <FormControlLabel
        value="any"
        control={<Radio color="primary" />}
        label="Any Time"
        disabled={disabled}
      />
      <FormControlLabel
        value="range"
        control={<Radio color="primary" />}
        label="Time Range"
        disabled={disabled}
      />
    </Box>
  </RadioGroup>
);
TimeRangeRadios.propTypes = {
  radio: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  }).isRequired,
};

export default TimeRangeRadios;
